import React, { useEffect, useState } from 'react';
import './AddedDetailsSectionStyle.scss';
import dot from '../../../../../Assets/dot.png';
import PropTypes from 'prop-types';

const AddedDetailsSection = ({ addedData = {}, formConfig = {} }) => {
  const [displayObj, setDisplayObj] = useState({});

  useEffect(() => {
    const labelValuePairs = formConfig.fields;
    const resultObject = {};
    labelValuePairs.forEach((pair) => {
      if (pair.name && pair.label && addedData.hasOwnProperty(pair.name)) {
        if (pair.translate) {
          const translatedKey = pair.name + '1';
          const secondLand = addedData.hasOwnProperty(translatedKey)
            ? ' / ' + addedData[translatedKey]
            : '';
          resultObject[pair.label] = addedData[pair.name] + secondLand;
        } else if (
          pair.type === 'file' &&
          addedData[pair.name] &&
          addedData[pair.name].name
        ) {
          resultObject[pair.label] = addedData[pair.name].name;
        } else if(pair.optionName) {
          resultObject[pair.label] = addedData[pair.optionName];
        } else if(pair.type === 'calendar') {
          resultObject[pair.label] =  addedData[pair.name].toString();
        } else{
          resultObject[pair.label] = addedData[pair.name];

        }
      }
    });
    setDisplayObj(resultObject);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (displayObj["Role :"] === "PHC MO") {
    delete displayObj["UPHC Name :"];
  } else if (displayObj["Role :"] === "UPHC MO") {
    delete displayObj["PHC Name :"];
  }
  return (
    <div className="m-3 master-form">
      <h1 className="text-base font-normal mb-4">Below Details Added :</h1>
      <div className="detail-section">
        {Object.entries(displayObj).map(([key, value]) => (
          <div className="p-2" key={`${key}_${value}`}>
            {value && value !== '' && (
              <>
                <span>
                  <img
                    style={{ width: '5px', height: '5px', marginBottom: '2px' }}
                    src={dot}
                    alt=""
                  />
                </span>
                <span className="text-base font-normal ml-2">{key} </span>
                <span className="text-base font-semibold">{value}</span>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

AddedDetailsSection.propTypes = {
  addedData: PropTypes.object.isRequired,
  formConfig: PropTypes.object.isRequired,
};

export default AddedDetailsSection;
